import { logout } from '@zet/common/utils/logout'
import storage from '@zet/utils/storage'
import { getUserRefreshToken } from '@zet/utils/userToken'

import { zetApi } from '..'

export async function fetchRefreshToken() {
  try {
    const userId = storage.getObject('userId')
    if (!userId) {
      throw new Error('User Id is not stored for this user')
    }
    const refreshToken = getUserRefreshToken()
    const { data } = await zetApi.post(`user/refreshToken?id=${userId}`, {
      refreshToken,
    })
    zetApi.defaults.headers.common = {
      ...zetApi.defaults.headers.common,
      Authorization: `Bearer ${data?.data?.accessToken}`,
    }
    data?.data?.refreshToken &&
      storage.saveObject('refreshToken', data?.data.refreshToken)
    data?.data?.accessToken &&
      storage.saveObject('token', data?.data.accessToken)
    data?.data?.expiryDate &&
      storage.saveObject('expiryDate', data?.data.expiryDate)
  } catch (error) {
    logout()
  } finally {
    // eslint-disable-next-line no-unsafe-finally
    return true
  }
}

const refreshExpiredTokenClosure = () => {
  let isCalled = false
  const setIsCalledToFalse = () => {
    isCalled = false
  }
  return async () => {
    if (!isCalled) {
      isCalled = true
      const tokenReFetchedCalled = await fetchRefreshToken()
      tokenReFetchedCalled && setTimeout(() => setIsCalledToFalse(), 5000)
      return tokenReFetchedCalled
    }
  }
}

export const refreshToken = refreshExpiredTokenClosure()
